var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"pb-10",attrs:{"cols":"12","sm":"3"}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.incrementStep}},[_vm._v("Continue")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }